'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _quickDepositConstants = require('@wh/quick-deposit-constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SecurePaymentPanel component.
 * @param {SecurePaymentPropsType} props element
 * @returns {ReactElement} React element
 */
/**
 * SecurePaymentPanel component.
 * @param {SecurePaymentPropsType} props element
 * @returns {ReactElement} React element
 */
var SecurePaymentPanelComponent = function (_React$Component) {
  (0, _inherits3.default)(SecurePaymentPanelComponent, _React$Component);

  function SecurePaymentPanelComponent() {
    (0, _classCallCheck3.default)(this, SecurePaymentPanelComponent);
    return (0, _possibleConstructorReturn3.default)(this, (SecurePaymentPanelComponent.__proto__ || (0, _getPrototypeOf2.default)(SecurePaymentPanelComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SecurePaymentPanelComponent, [{
    key: 'UNSAFE_componentWillMount',


    /**
     * [componentWillMount description]
     * @return {[type]} [description]
     */
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      /**
       * message event handler
       * @param  {Event} event message event
       * @return {void}
       */
      var handler = function handler(event) {
        _this2.paymentsMessageHandler(event);
      };
      this.setState({ handler: handler });
    }

    /**
     * Sumbits the 3ds init form and add an event listener for the term url postMessage
     * @returns {void}
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var messageHandler = this.state.handler;
      window.addEventListener('message', messageHandler);
      this.securePaymentForm.submit();
      this.timeElapsedOn3ds = Date.now();
    }

    /**
     * Remove the event listener.
     * @returns {void}
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removePaymentsMessageHandler();
    }

    /**
     * Removed the handler for the post message from 3ds payment term url
     * @returns {void}
     **/

  }, {
    key: 'removePaymentsMessageHandler',
    value: function removePaymentsMessageHandler() {
      window.removeEventListener('message', this.state.handler);
    }

    /**
     * Tracks necessary events and runs callback if exist
     * @param {MD} MD param from iframe
     * @param {PaRes} PaRes param from iframe
     * @returns {void}
     **/

  }, {
    key: 'processWrongIframeParams',
    value: function processWrongIframeParams(MD, PaRes) {
      var _props = this.props,
          activeDepositData = _props.activeDepositData,
          onPaymentError = _props.onPaymentError,
          trackingData = _props.trackingData,
          trackEvent = _props.trackEvent;

      // we are traking event if there is no onPaymentError callback because this callback will have traking inside

      !MD && !onPaymentError && trackEvent(_quickDepositConstants.MESSAGE_TRACKING_QD_UNSUCCESSFUL, {
        EffortAttempt: trackingData.submitCount.toString(),
        ErrorFields: _quickDepositConstants.GENERIC_ERROR_FIELD_IDENTIFIER,
        ErrorFieldsAmount: '1',
        ErrorMessages: 'Merchant Data is missing',
        ErrorCode: null,
        DepositAmount: activeDepositData.amount
      });

      !PaRes && !onPaymentError && trackEvent(_quickDepositConstants.MESSAGE_TRACKING_QD_UNSUCCESSFUL, {
        EffortAttempt: trackingData.submitCount.toString(),
        ErrorFields: _quickDepositConstants.GENERIC_ERROR_FIELD_IDENTIFIER,
        ErrorFieldsAmount: '1',
        ErrorMessages: 'Payment authentication response is missing',
        ErrorCode: null,
        DepositAmount: activeDepositData.amount
      });

      if (onPaymentError && onPaymentError instanceof Function) {
        onPaymentError(new Error('Secure Payment Error'));
      }
    }

    /**
     * Handle the postMessage event coming from the 3ds payment term url
     *
     * @param {Event} event The postMessage event
     * @returns {void}
     */

  }, {
    key: 'paymentsMessageHandler',
    value: function paymentsMessageHandler(event) {
      if (event && this.iframe && this.iframe.contentWindow === event.source) {
        var _ref = (event || {}).data || {},
            MD = _ref.MD,
            PaRes = _ref.PaRes,
            csrf = _ref.csrf;

        var _props2 = this.props,
            _complete3DS = _props2.complete3DS,
            _securePaymentData = _props2.securePaymentData;


        if (!MD || !PaRes) {
          this.processWrongIframeParams(MD, PaRes);
          return;
        }

        var TermUrl = _securePaymentData.data.TermUrl;


        this.removePaymentsMessageHandler();
        _complete3DS({
          MD: MD,
          PaRes: PaRes,
          csrf: csrf,
          TermUrl: TermUrl
        });
      }
    }

    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$securePaymentD = this.props.securePaymentData,
          securePaymentData = _props$securePaymentD === undefined ? {} : _props$securePaymentD;


      var params = securePaymentData.data || {};
      //make sure the iframe has a unique name in the case more than one
      //QD component is added to the same page
      var iframeRef = 'qd-3ds-iframe-' + Date.now();

      return _react2.default.createElement(
        'div',
        { className: 'qd-3ds__wrapper' },
        _react2.default.createElement('iframe', {
          ref: function ref(iframe) {
            _this3.iframe = iframe;
          },
          name: iframeRef,
          id: 'qd-3ds-iframe',
          allowFullScreen: true,
          allowTransparency: true
        }),
        _react2.default.createElement(
          'form',
          {
            className: 'hidden',
            ref: function ref(form) {
              _this3.securePaymentForm = form;
            },
            action: securePaymentData.url,
            target: iframeRef,
            method: securePaymentData.type
          },
          _react2.default.createElement('input', { type: 'hidden', value: params.PaReq, name: 'PaReq', id: 'qd-PaReq' }),
          _react2.default.createElement('input', { type: 'hidden', value: params.MD, name: 'MD', id: 'qd-MD' }),
          _react2.default.createElement('input', { type: 'hidden', value: params.TermUrl, name: 'TermUrl', id: 'qd-TermUrl' })
        )
      );
    }
  }]);
  return SecurePaymentPanelComponent;
}(_react2.default.Component);

exports.default = SecurePaymentPanelComponent;